<template>
  <VLayout
    :title="$t('not_found.title')"
    :subtitle="$t('not_found.text')"
  >

  </VLayout>
</template>

<script>
import VLayout from "@/layouts/Default";

export default {
  components: {
    VLayout,
  },
  fallbackI18n: {
    messages: {
      und: {
        not_found: {
          title: "Page not found",
          text: "Sorry, but the page you are looking was not found. Please make sure you have entered the correct URL.",
        },
      },
    },
  },
};
</script>
